(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fts-back-navigation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-fts-back]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  try {
    const previous = new URL(document.referrer);
    if (previous.origin === window.location.origin && previous.pathname !== window.location.pathname && window.history.length > 1) {
      event.preventDefault();
      window.history.back();
    }
  } catch {}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fts-shirt-wheel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fts-shirt-wheel')){
  customElements.define('fts-shirt-wheel',class extends HTMLElement{
    async connectedCallback(){
      if(this.started)return;
      this.started=true;
      this.abort=new AbortController();
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.paused=this.dataset.auto!=='true'||this.motion.matches;
      this.step=0;this.angle=0;this.target=0;this.frame=0;this.dragged=false;
      this.stage=this.querySelector('.fts-wheel__stage');
      this.focusBox=this.querySelector('.fts-wheel__focus');
      this.orbit=this.querySelector('.fts-wheel__orbit');
      let source=this.querySelector('.fts-wheel__products');
      if(this.dataset.sorted==='true'){
        try{
          const url=new URL(this.dataset.url,location.origin);
          url.searchParams.set('sort_by','best-selling');
          url.searchParams.set('section_id',this.dataset.section);
          const preview=new URLSearchParams(location.search).get('preview_theme_id');
          if(preview)url.searchParams.set('preview_theme_id',preview);
          const response=await fetch(url,{signal:this.abort.signal});
          if(!response.ok)throw Error('Section unavailable');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const sorted=doc.querySelector('.fts-wheel__products');
          if(sorted&&sorted.children.length)source=sorted;
        }catch(error){if(error.name==='AbortError')return;}
      }
      if(!this.isConnected)return;
      this.products=[...source.querySelectorAll('.fts-wheel__product')].slice(0,Number(this.dataset.limit));
      if(!this.products.length)return;
      this.orbit.replaceChildren();
      this.buttons=this.products.map((product,index)=>{
        const button=document.createElement('button');
        button.type='button';button.className='fts-wheel__thumb';
        button.setAttribute('aria-label',product.dataset.title);
        const image=product.querySelector('img,svg').cloneNode(true);
        if(image.tagName==='IMG'){image.sizes='62px';image.alt='';image.draggable=false;}
        button.append(image);
        button.addEventListener('click',()=>{if(!this.dragged){this.stop();this.select(this.step+this.shortest(index-this.index));}});
        this.orbit.append(button);return button;
      });
      this.querySelector('.fts-wheel__interactive').hidden=false;
      this.classList.add('is-ready');
      const signal=this.abort.signal;
      this.querySelector('[data-prev]').addEventListener('click',()=>{this.stop();this.select(this.step-1);},{signal});
      this.querySelector('[data-next]').addEventListener('click',()=>{this.stop();this.select(this.step+1);},{signal});
      this.pauseButton=this.querySelector('[data-pause]');
      this.pauseButton.hidden=this.dataset.auto!=='true'||this.products.length<2;
      this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.pauseLabel();this.timer();},{signal});
      this.addEventListener('keydown',event=>{
        if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.stop();this.select(this.step+(event.key==='ArrowLeft'?-1:1));}
        if(event.key==='Home'||event.key==='End'){event.preventDefault();this.stop();this.select(event.key==='Home'?0:this.products.length-1);}
      },{signal});
      this.stage.addEventListener('pointerdown',event=>{
        if(event.button!==0||event.target.closest('a'))return;
        this.stop();this.dragged=false;
        this.drag={id:event.pointerId,x:event.clientX,y:event.clientY,angle:this.angle};
      },{signal});
      this.stage.addEventListener('pointermove',event=>{
        if(!this.drag||this.drag.id!==event.pointerId)return;
        const dx=event.clientX-this.drag.x;
        if(!this.dragged&&Math.abs(event.clientY-this.drag.y)>Math.abs(dx))return;
        if(Math.abs(dx)>7){this.dragged=true;this.stage.setPointerCapture(event.pointerId);this.angle=this.drag.angle+dx/this.stage.clientWidth*280;this.target=this.angle;this.position();}
      },{signal});
      const release=()=>{
        if(!this.drag)return;
        this.drag=null;
        if(this.dragged)this.select(Math.round(-this.angle/(360/this.products.length)));
        setTimeout(()=>{this.dragged=false;},0);
      };
      this.stage.addEventListener('pointerup',release,{signal});
      this.stage.addEventListener('pointercancel',release,{signal});
      this.addEventListener('mouseenter',()=>{this.hovered=true;},{signal});
      this.addEventListener('mouseleave',()=>{this.hovered=false;},{signal});
      this.addEventListener('focusin',event=>{if(event.target!==this.pauseButton)this.stop();},{signal});
      this.motion.addEventListener('change',()=>{if(this.motion.matches)this.stop();},{signal});
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;});
      this.observer.observe(this);
      if(!this.resize){this.resize=new ResizeObserver(()=>this.position());this.resize.observe(this.stage);}
      this.select(0,false);this.pauseLabel();this.timer();
    }
    shortest(delta){const n=this.products.length;return ((delta+n/2+n)%n)-n/2;}
    select(step,announce=true){
      this.step=step;const n=this.products.length;this.index=((step%n)+n)%n;
      this.target=-step*360/n;
      this.focusBox.replaceChildren(this.products[this.index].cloneNode(true));
      this.focusBox.querySelectorAll('img').forEach(img=>{img.loading='eager';img.draggable=false;});
      this.buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===this.index)));
      const counter=String(this.index+1).padStart(2,'0')+' / '+String(n).padStart(2,'0');
      this.querySelector('.fts-wheel__count').textContent=counter;
      if(announce)this.querySelector('.fts-wheel__status').textContent=counter+' '+this.products[this.index].dataset.title;
      if(this.motion.matches){this.angle=this.target;this.position();}else this.animate();
    }
    position(){
      const radius=this.stage.clientWidth*.43;
      this.buttons.forEach((button,index)=>{
        const rad=(index*360/this.products.length+this.angle-90)*Math.PI/180;
        button.style.transform='translate(calc(-50% + '+Math.cos(rad)*radius+'px),calc(-50% + '+Math.sin(rad)*radius+'px))';
      });
    }
    animate(){
      cancelAnimationFrame(this.frame);
      const tick=()=>{this.angle+=(this.target-this.angle)*.14;if(Math.abs(this.target-this.angle)<.08)this.angle=this.target;this.position();if(this.angle!==this.target)this.frame=requestAnimationFrame(tick);};
      tick();
      if(!this.resize){this.resize=new ResizeObserver(()=>this.position());this.resize.observe(this.stage);}
    }
    pauseLabel(){if(this.pauseButton)this.pauseButton.textContent=this.querySelector(this.paused?'[data-play-text]':'[data-pause-text]').textContent;}
    stop(){this.paused=true;this.pauseLabel();clearInterval(this.interval);}
    timer(){clearInterval(this.interval);if(!this.paused&&this.products.length>1)this.interval=setInterval(()=>{if(this.visible&&!this.hovered&&!document.hidden&&(!this.contains(document.activeElement)||document.activeElement===this.pauseButton))this.select(this.step+1,false);},Number(this.dataset.speed)*1000);}
    disconnectedCallback(){this.abort?.abort();clearInterval(this.interval);cancelAnimationFrame(this.frame);this.observer?.disconnect();this.resize?.disconnect();this.started=false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
